import React from "react";
import { useTranslation } from "react-i18next";
import { CustomButton } from "../../../atoms/CustomButton";
import useAuth from "../../../../hooks/useAuth";
import { PlanTier, usePermissions } from "../../../../utils/permissions";

interface WhatsappCreditWarningProps {
  whatsappCredit: number | null | undefined;
  configured: boolean | undefined;
  onAddCredit: () => void;
}

const LOW_THRESHOLD = 50;

const WhatsappCreditWarning: React.FC<WhatsappCreditWarningProps> = ({
  whatsappCredit,
  configured,
  onAddCredit,
}) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const permissions = usePermissions(user);

  if (!configured) return null;

  if (
    !permissions.isAtLeastTier(PlanTier.ENTERPRISE) ||
    permissions.isPromoTrial()
  ) {
    return null;
  }

  if (
    whatsappCredit !== undefined &&
    whatsappCredit !== null &&
    whatsappCredit >= LOW_THRESHOLD
  ) {
    return null;
  }

  const messageKey =
    whatsappCredit === undefined ||
    whatsappCredit === null ||
    whatsappCredit === 0
      ? "dashboard.whatsappCredit.noCreditsMessage"
      : "dashboard.whatsappCredit.lowCreditsMessage";

  return (
    <div className="mt-1 flex flex-col items-start gap-2">
      <p className="text-sm font-medium text-gray-700 font-figtree">
        {t(messageKey, { count: whatsappCredit || 0 })}
      </p>
      <CustomButton
        variant="primary"
        size="sm"
        onClick={onAddCredit}
        title={t("dashboard.whatsappCredit.addCreditsButton") as string}
      />
    </div>
  );
};

export default WhatsappCreditWarning;
